import { Component, OnDestroy, OnInit } from '@angular/core'
import { AbstractControl, UntypedFormControl, UntypedFormGroup } from '@angular/forms'
import { MatAutocompleteSelectedEvent } from '@angular/material/autocomplete'
import { ActivatedRoute } from '@angular/router'
import { Observable, Subscription, of } from 'rxjs'
import { filter, tap } from 'rxjs/operators'
import { NotificationService } from '../../../../../notification/shared/notification.service'
import { BasketService } from '../../../../basket/shared/basket.service'
import { Client } from '../../../../shared/client/client'
import { ClientService } from '../../../../shared/client/client.service'
import { Porteur } from '../../shared/porteur'
import { requireIfNullValidator } from './requireIfNullValidator'


@Component({
  selector: 'app-mutation',
  templateUrl: './mutation.component.html',
  styleUrls: ['./mutation.component.scss']
})
export class MutationComponent implements OnInit, OnDestroy {

  prevSearch: string = ""
  clients: Array<Client> = new Array<Client>()
  currentClient: Client
  listOfClients: Observable<Array<Client>> = new Observable<Array<Client>>()

  porteur: Porteur
  mutationForm: UntypedFormGroup = new UntypedFormGroup({
    'clientFilter': new UntypedFormControl(null),
    'newClient': new UntypedFormControl(undefined),
    'comment': new UntypedFormControl(""),
    'newCasier': new UntypedFormControl("")
  })

  subClient: Subscription

  constructor(
    private clientService: ClientService,
    private basketService: BasketService,
    private route: ActivatedRoute,
    private notificationService: NotificationService
  ) { }

  ngOnInit() {
    this.route.parent.data.subscribe(data => {
      this.porteur = data.porteur
    })
    this.mutationForm.setValidators(requireIfNullValidator(this.newClient, this.comment))

    this.subClient = this.clientService.getCurrentClient().subscribe(client => this.currentClient = client)
    this.listOfClients = this.updateClientFilter('')
    this.clientFilter.valueChanges.pipe(filter(client => typeof client === 'string')).subscribe(value => {
      this.listOfClients = this.updateClientFilter(value)
    })
  }

  ngOnDestroy(): void {
    if (this.subClient) {
      this.subClient.unsubscribe()
    }
  }

  displayFn(client?: Client): string | undefined {
    return client ? (client.site == null ? '' : client.site.numero + ': ') + client.code_client + "/" + client.code_service + " - " + client.raison_sociale : undefined
  }

  displayActual(client?: Client): string | undefined {
    return client ? (client.site == null ? '' : client.site.numero + ': ') + client.code_client + "/" + this.porteur.codeService.toString().padStart(2, '0') + " - " + client.raison_sociale : undefined
  }

  updateClientFilter(val: string): Observable<Client[]> {
    let ret: Observable<Client[]>
    if (this.clients == null || this.clients.length === 100 || this.clients.length === 0 || this.prevSearch.length > val.length) {
      ret = this.clientService.getClients(val).pipe(
        tap(clients => this.clients = clients.filter(client => client.id != this.currentClient.id))
      )
    } else {
      ret = of(this.clients.filter(client => {
        return this.displayFn(client).toLowerCase().indexOf(val.toLowerCase()) !== -1
      }))
    }
    this.prevSearch = val
    return ret
  }

  get newClient(): AbstractControl {
    return this.mutationForm.get("newClient")
  }

  get clientFilter(): AbstractControl {
    return this.mutationForm.get("clientFilter")
  }

  get newCasier(): AbstractControl {
    return this.mutationForm.get('newCasier')
  }

  get comment(): AbstractControl {
    return this.mutationForm.get('comment')
  }

  updateClient($event: MatAutocompleteSelectedEvent) {
    this.newClient.setValue($event.option.value)
  }

  displaySelected() {
    if (typeof this.clientFilter.value !== 'object') {
      this.clientFilter.setValue(this.newClient.value)
    }
  }

  private successAdd() {
    this.notificationService.notif("La demande de mutation a été ajoutée à votre panier", "notif")
  }

  private getSelectedClient(): Client {
    return this.newClient.value
  }

  submitForm() {
    if (this.mutationForm.valid && this.porteur !== undefined) {
      this.basketService.addBasketLine({
        type: "MUTATION PORTEUR",
        numPorteur: this.porteur.numPorteur,
        comment: this.comment.value,
        newClient: this.getSelectedClient() != null ? this.getSelectedClient().id : null,
        newCasier: this.newCasier.value,
        codeService: this.porteur.codeService,
      }).subscribe(ret => this.successAdd())
    }
  }
}
